var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ExplainSearchBoxBase',[_c(_vm.xSearchBoxComponent,{tag:"component",class:_vm.baseClass,attrs:{"size":"large","input-query":_vm.inputQuery,"placeholder":_vm.computedPlaceholder,"disabled":_vm.disabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }